export enum PersonSourceEnum {
    MANUAL = 'manual',
    WIKIDATA = 'wikidata',
    SEED = 'seed',
    /** Candidate found by the AI city researcher (web search). */
    AI_RESEARCH = 'ai_research',
}
